
const ProceedButton = ({ handleClick }: any) => {
    return (
        <button className="outline-icon-btn" onClick={handleClick} type="button">PROCEED</button>
    )
}

export default ProceedButton